import React, { useMemo, useState } from "react";
import {
  Box,
  Paper,
  Tabs,
  Tab,
  Typography,
} from "@mui/material";
import { MaterialReactTable, MRT_ColumnDef } from "material-react-table";

// Demo Swaps Data (shortened for example)
const swapsData = [
  { product: "Crude Oil and Refined Products", contract: "Brent 1st Line Mini Future", logicalCode: "IMM", physicalCode: "IMM", lotSize: "100 bbl", screen: "$0.13", clearScreen: "$0.13", clearBlock: "$0.13", cashSettle: "$0.01" },
  { product: "Crude Oil and Refined Products", contract: "Brent 1st Line Future", logicalCode: "BRN", physicalCode: "I", lotSize: "1,000 bbl", screen: "$1.25", clearScreen: "$1.34", clearBlock: "$1.34", cashSettle: "$0.09" },
  { product: "Crude Oil and Refined Products", contract: "Dated Brent Mini Future", logicalCode: "PDM", physicalCode: "PDM", lotSize: "100 bbl", screen: "$0.10", clearScreen: "$0.11", clearBlock: "$0.11", cashSettle: "$0.01" },
  { product: "Crude Oil and Refined Products", contract: "Fuel Oil 1% CIF Med Cargoes Future", logicalCode: "CIF", physicalCode: "CIF", lotSize: "1,000 mt", screen: "$21.50", clearScreen: "$11.00", clearBlock: "$11.50", cashSettle: "$1.00" },
  { product: "Crude Oil and Refined Products", contract: "Fuel Oil 3.5% CIF Med Cargoes Future", logicalCode: "CIM", physicalCode: "CIM", lotSize: "1,000 mt", screen: "$22.00", clearScreen: "$11.20", clearBlock: "$11.00", cashSettle: "$1.05" },
  { product: "Crude Oil and Refined Products", contract: "Marine Fuel 0.5% FOB Med Mini Future", logicalCode: "FNS", physicalCode: "FNU", lotSize: "100 mt", screen: "$2.18", clearScreen: "$1.10", clearBlock: "$1.12", cashSettle: "$0.10" },
  { product: "Crude Oil and Refined Products", contract: "WTI Midland vs Dated Brent Future", logicalCode: "CGG", physicalCode: "CGG", lotSize: "1,000 bbl", screen: "$1.50", clearScreen: "$1.34", clearBlock: "$1.36", cashSettle: "$0.09" },
  { product: "Crude Oil and Refined Products", contract: "Urals Med vs Dated Brent Balmo Future", logicalCode: "UCG", physicalCode: "UCG", lotSize: "1,000 bbl", screen: "$1.28", clearScreen: "$1.30", clearBlock: "$1.32", cashSettle: "$0.09" },
  { product: "Crude Oil and Refined Products", contract: "Daily BFOET M2 Future", logicalCode: "BF2", physicalCode: "BF2", lotSize: "1,000 bbl", screen: "$1.20", clearScreen: "$1.33", clearBlock: "$1.34", cashSettle: "$0.08" },
  { product: "Crude Oil and Refined Products", contract: "Daily BFOET M3 Future", logicalCode: "BF3", physicalCode: "BF3", lotSize: "1,000 bbl", screen: "$1.22", clearScreen: "$1.35", clearBlock: "$1.36", cashSettle: "$0.09" },
  { product: "Crude Oil and Refined Products", contract: "Fuel Oil Outright Marine 0.5% FOB Singapore Micro Future", logicalCode: "GNU", physicalCode: "GNU", lotSize: "10 mt", screen: "$0.22", clearScreen: "$0.11", clearBlock: "$0.12", cashSettle: "$0.01" },
  { product: "Crude Oil and Refined Products", contract: "Fuel Oil Outright Marine 0.5% FOB Rotterdam Micro Future", logicalCode: "GNV", physicalCode: "GNV", lotSize: "10 mt", screen: "$0.21", clearScreen: "$0.11", clearBlock: "$0.11", cashSettle: "$0.01" },
  { product: "Crude Oil and Refined Products", contract: "Daily CPC Blend vs Dated Brent Future", logicalCode: "DCW", physicalCode: "DCW", lotSize: "1,000 bbl", screen: "$1.25", clearScreen: "$1.34", clearBlock: "$1.34", cashSettle: "$0.09" },
  { product: "Crude Oil and Refined Products", contract: "CPC Blend CIF Future", logicalCode: "JFI", physicalCode: "JFI", lotSize: "1,000 bbl", screen: "$1.26", clearScreen: "$1.34", clearBlock: "$1.34", cashSettle: "$0.09" },
  { product: "Crude Oil and Refined Products", contract: "Dated Brent vs Brent 1st Line Future", logicalCode: "DBF", physicalCode: "DBF", lotSize: "1,000 bbl", screen: "$1.27", clearScreen: "$1.35", clearBlock: "$1.36", cashSettle: "$0.09" },
  { product: "Crude Oil and Refined Products", contract: "Daily Dated Brent vs Mediterranean Future", logicalCode: "DDM", physicalCode: "DDM", lotSize: "1,000 bbl", screen: "$1.23", clearScreen: "$1.34", clearBlock: "$1.35", cashSettle: "$0.09" },
  { product: "Crude Oil and Refined Products", contract: "Weekly CFD Dated Brent vs BFOE First Month", logicalCode: "CFD", physicalCode: "CFD", lotSize: "1,000 bbl", screen: "$1.25", clearScreen: "$1.34", clearBlock: "$1.34", cashSettle: "$0.02" },
  { product: "Crude Oil and Refined Products", contract: "Weekly CFD Dated Brent vs BFOE Second Month", logicalCode: "CFT", physicalCode: "CFT", lotSize: "1,000 bbl", screen: "$1.26", clearScreen: "$1.34", clearBlock: "$1.34", cashSettle: "$0.02" },
  { product: "Crude Oil and Refined Products", contract: "Monthly CFD Dated Brent vs BFOE First Month", logicalCode: "CFM", physicalCode: "CFM", lotSize: "1,000 bbl", screen: "$1.28", clearScreen: "$1.34", clearBlock: "$1.35", cashSettle: "$0.09" },
  { product: "Crude Oil and Refined Products", contract: "Monthly CFD Dated Brent vs BFOE Second Month", logicalCode: "CFL", physicalCode: "CFL", lotSize: "1,000 bbl", screen: "$1.29", clearScreen: "$1.34", clearBlock: "$1.36", cashSettle: "$0.09" },
];


// Placeholder for Futures (you can add later)
const futuresData = [
  { product: "Crude Oil and Refined Products", contract: "Brent Crude Futures", logicalCode: "", physicalCode: "", lotSize: "1000", screen: "0.88", clearScreen: "0.25", clearBlock: "0.09", cashSettle: "0.09" },
  { product: "Crude Oil and Refined Products", contract: "LS Gasoil Futures", logicalCode: "", physicalCode: "", lotSize: "100", screen: "0.88", clearScreen: "0.25", clearBlock: "0.09", cashSettle: "0.09" },
  { product: "Crude Oil and Refined Products", contract: "Heating Oil Futures", logicalCode: "", physicalCode: "", lotSize: "1000", screen: "0.88", clearScreen: "0.25", clearBlock: "0.09", cashSettle: "0.09" },
  { product: "Crude Oil and Refined Products", contract: "ICE RBOB", logicalCode: "", physicalCode: "", lotSize: "1000", screen: "0.88", clearScreen: "0.25", clearBlock: "0.09", cashSettle: "0.09" },
  { product: "Crude Oil and Refined Products", contract: "ICE WTI", logicalCode: "", physicalCode: "", lotSize: "1000", screen: "0.88", clearScreen: "0.25", clearBlock: "0.09", cashSettle: "0.09" },
];


const swapsColumns = [
  { accessorKey: "product", header: "Products" },
  { accessorKey: "contract", header: "Contracts" },
  { accessorKey: "logicalCode", header: "Logical Code" },
  { accessorKey: "physicalCode", header: "Physical Code" },
  { accessorKey: "lotSize", header: "Lot Size" },
  { accessorKey: "screen", header: "Screen" },
  { accessorKey: "clearScreen", header: "ICE Clear EU Screen" },
  { accessorKey: "clearBlock", header: "ICE Clear EU Block, EFS" },
  { accessorKey: "cashSettle", header: "Cash Settle (per lot)" },
];

// Futures Columns
const futuresColumns = [
  { accessorKey: "product", header: "Products" },
  { accessorKey: "contract", header: "Contracts" },
  { accessorKey: "lotSize", header: "Lot Size" },
  { accessorKey: "exchange", header: "Exchange" },
  { accessorKey: "clearing", header: "Clearing" },
  { accessorKey: "cashSettle", header: "Cash Settle" },
];

const ExchangeAndClearing: React.FC = () => {
  const [tab, setTab] = useState(0);

  return (
    <Box sx={{ p: 2, mt: 3, marginTop: "140px" }}>
      <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
        ICE Exchange&Clearing Fees
      </Typography>

      {/* Tabs */}
      <Paper sx={{ mb: 2 }}>
        <Tabs value={tab} onChange={(_, v) => setTab(v)} indicatorColor="primary" textColor="primary">
          <Tab label="Swaps" />
          <Tab label="Futures" />
        </Tabs>
      </Paper>

      {/* Swaps Table */}
      {tab === 0 && (
        <Paper sx={{ border: "1px solid #e0e0e0", borderRadius: 2, boxShadow: "0 2px 6px rgba(0,0,0,0.08)", background: "linear-gradient(to bottom, #ffffff, #f9f9fb)" }}>
          <MaterialReactTable
            columns={swapsColumns}
            data={swapsData}
            enableColumnFilters
            enableSorting
            enablePagination={false}
            enableDensityToggle={false}
            enableColumnPinning
            initialState={{ showColumnFilters: true, density: "compact", columnPinning: { left: ["product", "contract"] } }}
            muiTableContainerProps={{ sx: { maxHeight: "65vh" } }}
            muiTableHeadCellProps={{ sx: { fontSize: "0.72rem", fontWeight: 600, backgroundColor: "#f5f6f8", color: "#2c3e50" } }}
            muiTableBodyCellProps={{ sx: { fontSize: "0.7rem", padding: "4px 6px", "&:hover": { backgroundColor: "#fafafa" } } }}
            muiTopToolbarProps={{ sx: { minHeight: "36px", py: 0.5, "& .MuiButtonBase-root": { fontSize: "0.7rem", padding: "2px 6px", minWidth: "auto", height: 28 }, "& .MuiInputBase-root": { fontSize: "0.7rem", height: 28, "& input": { p: "0 6px" } } } }}
            renderEmptyRowsFallback={() => <Typography sx={{ p: 2, fontStyle: "italic", textAlign: "center" }}>No Swaps Data Available</Typography>}
          />
        </Paper>
      )}

      {/* Futures Table */}
      {tab === 1 && (
        <Paper sx={{ border: "1px solid #e0e0e0", borderRadius: 2, boxShadow: "0 2px 6px rgba(0,0,0,0.08)", background: "linear-gradient(to bottom, #ffffff, #f9f9fb)" }}>
          <MaterialReactTable
            columns={futuresColumns}
            data={futuresData}
            enableColumnFilters
            enableSorting
            enablePagination={false}
            enableDensityToggle={false}
            enableColumnPinning
            initialState={{ showColumnFilters: true, density: "compact", columnPinning: { left: ["product", "contract"] } }}
            muiTableContainerProps={{ sx: { maxHeight: "65vh" } }}
            muiTableHeadCellProps={{ sx: { fontSize: "0.72rem", fontWeight: 600, backgroundColor: "#f5f6f8", color: "#2c3e50" } }}
            muiTableBodyCellProps={{ sx: { fontSize: "0.7rem", padding: "4px 6px", "&:hover": { backgroundColor: "#fafafa" } } }}
            muiTopToolbarProps={{ sx: { minHeight: "36px", py: 0.5, "& .MuiButtonBase-root": { fontSize: "0.7rem", padding: "2px 6px", minWidth: "auto", height: 28 }, "& .MuiInputBase-root": { fontSize: "0.7rem", height: 28, "& input": { p: "0 6px" } } } }}
            renderEmptyRowsFallback={() => <Typography sx={{ p: 2, fontStyle: "italic", textAlign: "center" }}>No Futures Data Available</Typography>}
          />
        </Paper>
      )}
    </Box>
  );
};

export default ExchangeAndClearing;


